export enum ProcessingMode {
  PerPage = "per-page",
  PerFile = "per-file",
  MultipleDocumentsPerPage = "multiple-documents-per-page",
}
